export default {
  created: function () { },
  data: function () {
    return {
      url: {
        serverUrl:  process.env.VUE_APP_URL,
        Auth: {
          Login: "User/Login",
          Register: "User/CreateUser",
          IsUserNameExist: "User/IsUserNameExist/",
          GetRoles: "User/GetRoles",
          GetUsers: "User/GetUsers",
          ChangePassword: "User/ChangePassword",
          ChangeRoles: "User/ChangeRoles",
        },
        Delivery: {
          GetDeliveryQuestions: "Delivery/GetDeliveryQuestions",
          GetDeliveryVehicles: "Delivery/GetDeliveryVehicles",
          GetRawMaterialDeliveries: "Delivery/GetRawMaterialDeliveries?page=",
          GetDeliveryStickers:"Delivery/GetDeliveryStickers/",
        },
        Vechicles: {
          AddDeliveryVehicle: "Vehicle/AddDeliveryVehicle",
          GetVechicles: "Vehicle/GetDeliveryVehicles",
          EditVehicle: "Vehicle/EditVehicle",
          RemoveVehicle: "Vehicle/RemoveVehicle",
        },
        RawMaterial: {
          GetRawMaterialTypes: "RawMaterials/GetRawMaterialTypes",
          AddRawMaterialType: "RawMaterials/AddRawMaterialType",
          GetAvaiableRawMaterials: "RawMaterials/GetAvailableRawMaterials",
          GetAvailableRawMaterialsById: "RawMaterials/GetAvailableRawMaterialsByRawMaterialTypeId/{id}",
          EditRawMaterialType: "RawMaterials/EditRawMaterialType",
          DeleteRawMaterialType: "RawMaterials/DeleteRawMaterialType",
        },
        Country: {
          GetCountry: "Country",
        },
        Producer: {
          GetProducer: "Producer",
          AddProducer: "Producer/AddProducer",
          AddCertificate: "Producer/AddCertificate",
          ChangeName: "Producer/ChangeProducerName",
          EditCertificate: "Producer/EditCertificate",
        },
        Mill: {
          GetMills: "Mill/GetMills",
          AddMill: "Mill/AddMill",
          EditMill: "Mill/EditMill",
          RemoveMill: "Mill/RemoveMill",
          GetMillsDetails: "Mill/GetMillsDetails",
        },
        Couverture: {
          CreateCouverture: "Couverture/CreateCouverture",
          EditCouverture: "Couverture/EditCouverture",
          GetCouvertureInformationsById: "Couverture/GetCouvertureInformationsById/",
          TakeOutCouverture: "Couverture/TakeOutCouverture/",
          GetCouvertures: "Couverture/GetCouvertures",
          GetCouverturesOnShelf: "Couverture/GetCouverturesOnShelf",
          GetCouverturesOnShelfByRecipeId: "Couverture/GetCouverturesOnShelfByRecipeId",
          MixCouvertures: "Couverture/MixCouvertures",
          GetHistoryForCouverture: "Couverture/GetHistoryForCouverture/",
          MixCouverturesFromShelf: "Couverture/MixCouverturesFromShelf",
          GetAvailableMeltDownProducts: "Couverture/GetAvailableMeltDownProducts",
          ChangeCouvertureRecipe: "Couverture/ChangeCouvertureRecipe",
        },
        Recipe: {
          GetRecipes: "Recipe/GetRecipes",
        },
        RecipeCoating: {
          CreateRecipe: "RecipeCoating/CreateRecipe",
          GetRecipes: "RecipeCoating/GetRecipes",
          EditRecipe: "RecipeCoating/EditRecipe",
          RemoveRecipe: "RecipeCoating/RemoveRecipe",
        },
        Barrel: {
          GetBarrels: "Barrel/GetBarrels",
          AddBarrel: "Barrel/AddBarrel",
          EditBarrel: "Barrel/EditBarrel",
          RemoveBarrel: "Barrel/RemoveBarrel",
          GetBarrelsDetails:"Barrel/GetBarrelsDetails",
          TakeOutCoatingProduct:"Barrel/TakeOutCoatingProduct",
          PutInCoatingProductToBarrel:"Barrel/PutInCoatingProductToBarrel",
          GetAvailableBarrels:"Barrel/GetAvailableBarrels",
          CreateCoatingProduct:"Barrel/CreateCoatingProduct",
          GetBarrelsDetailsById:"Barrel/GetBarrelsDetailsById/{id}",
        },
        CoatingProduct:{
          Create:"CoatingProduct/Create",
          Edit:"CoatingProduct/Edit",
          GetHistoryForCoatingProduct:"CoatingProduct/GetHistoryForCoatingProduct/",
          GetCoatingProducts:"CoatingProduct/GetCoatingProducts",
          GetCoatingProductTotalCount:"CoatingProduct/GetCoatingProductTotalCount",
          GetCoatingProductByBarrelId:"CoatingProduct/GetCoatingProductByBarrelId/",
          EditClearChocolate:"CoatingProduct/EditClearChocolate",
          GetCoatingProductById:"CoatingProduct/GetCoatingProductById/{id}",
          EditChocolateWithIngredients:"CoatingProduct/EditChocolateWithIngredients",
          CreateCoatingProductWithBiscuit:"CoatingProduct/CreateCoatingProductWithBiscuit",
          EditCoatingProductWithBiscuit:"CoatingProduct/EditCoatingProductWithBiscuit",
          CreateCream:"CoatingProduct/CreateCream",
          EditCream:"CoatingProduct/EditCream"
        },
        CoolingTunnel:{
          Create:"CoolingTunnel/Create",
          Edit:"CoolingTunnel/Edit",
          Remove:"CoolingTunnel/Remove/",
          Get:"CoolingTunnel",
        },
        ChocolateSharpener:{
          Create:"ChocolateSharpener/Create",
          Update:"ChocolateSharpener/Update",
          Remove:"ChocolateSharpener/Remove/",
          AssignComposition:"ChocolateSharpener/AssignComposition",
        }
      },
    };
  },
};
